module.exports = __webpack_public_path__ + "static/media/13.3c50cbbf.jpg";